import React, { useContext, useEffect, useState } from "react";
import {
  ManageMastersLayout,
  SearchComponent,
  CsplTable as Table,
} from "../../../components";
import { manageMasterStore } from "../../../contexts";
import { getClearingPartnerAccountPlans } from "../../../services";
import { isEmpty, get } from "lodash";

const ClearingPartnerAccountPlanContainer = (props) => {
  const { state, dispatch } = useContext(manageMasterStore);

  const [
    clearingPartnerAccountPlansFiltered,
    setClearingPartnerAccountPlansFiltered,
  ] = useState([]);
  const [
    clearingPartnerAccountPlans,
    setClearingPartnerAccountPlans,
  ] = useState([]);
  const clearingPartnerAccountId = get(state, "clearingPartnerAccountId", 0);
  useEffect(() => {
    if (clearingPartnerAccountId) {
      getClearingPartnerAccountPlans(clearingPartnerAccountId).then((res) => {
        if (res) {
          setClearingPartnerAccountPlansFiltered(res);
        }
      });
    }
  }, [clearingPartnerAccountId]);
  useEffect(() => {
    setClearingPartnerAccountPlans(clearingPartnerAccountPlansFiltered);
  }, [clearingPartnerAccountPlansFiltered]);
  const onSearchChange = (val) => {
    setClearingPartnerAccountPlans(
      clearingPartnerAccountPlansFiltered?.filter(
        (e) => e.planName.includes(val) || e.rkPlanNumber.includes(val)
      )
    );
  };
  return (
    <ManageMastersLayout layoutHeader="Clearing Partner Account Plan Details">
      <div className="clearing-partner-account-plan-container">
        <SearchComponent
          placeholder="Search by clearing partner ID, bank name"
          className="search-component-clearing-partner"
          onSearchChange={onSearchChange}
        />
        <div className="header-label">
          <div className="clearing-partner-subjects">
            <div className="clearing-partner-recently-added">
              Recently Added/Modified
            </div>
            <div className="clearing-partner-records">
              {clearingPartnerAccountPlans?.length ?? 0} Records found
            </div>
          </div>
        </div>
        <div className="clearing-partner-table">
          <div className="header-clearing-partner">
            <div className="table-header-clearing-partner">Plan Name</div>
            {/* <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" /> */}
          </div>
          <div className="header-clearing-partner">
            <div className="table-header-clearing-partner">Plan ID</div>
            {/* <FontAwesomeIcon icon={faSort} color="#BDBDBD" size="sm" /> */}
          </div>
        </div>
        <Table className="details-table">
          <Table.Tbody className="body-tables">
            {!isEmpty(clearingPartnerAccountPlans) &&
              clearingPartnerAccountPlans.map((e, i) => (
                <Table.Tr className="data-row">
                  <div className="table-details">{e.planName}</div>
                  <div className="table-details">{e.rkPlanNumber}</div>
                </Table.Tr>
              ))}
          </Table.Tbody>
        </Table>
      </div>
    </ManageMastersLayout>
  );
};

export default ClearingPartnerAccountPlanContainer;
